type StatusCount = {
    pending: number;
    completed: number;
    cancelled: number;
};

export const countStatuses = (data: { status: string }[]): StatusCount => {
    return data.reduce(
        (acc, item) => {
            if (item.status === 'pending' || item.status === 'partially_filled') {
                acc.pending += 1;
            } else if (item.status === 'completed') {
                acc.completed += 1;
            } else if (item.status === 'cancelled') {
                acc.cancelled += 1;
            }
            return acc;
        },
        { pending: 0, completed: 0, cancelled: 0 }
    );
};